import React from 'react';

/**
 * Shared automation name and description fields for Step5Trigger and Step6Review.
 */
const AutomationNameAndDescriptionFields = ({ formData, onSetFormData }) => (
  <>
    <div className="form-field">
      <label>Automation name</label>
      <input
        className="resui-input"
        type="text"
        placeholder="Enter automation name"
        value={formData.automationName ?? ''}
        onChange={(e) => onSetFormData({ ...formData, automationName: e.target.value })}
      />
    </div>
    <div className="form-field">
      <label>Description (optional)</label>
      <textarea
        className="resui-textarea"
        placeholder="Describe what this automation does"
        value={formData.description ?? ''}
        onChange={(e) => onSetFormData({ ...formData, description: e.target.value })}
        rows={3}
      />
    </div>
  </>
);

export default AutomationNameAndDescriptionFields;
